import { ReactNode } from 'react';
import HIcon from '../../../app/modules/payment/components/HIcon.tsx';
import icons from '../../utils/icons.ts';
import {Link} from "react-router";

export interface MediaInfoCellProps {
  media: {
    initial?: string;
    avatar?: string;
    title: string;
    subtitle?: string;
    url?: string;
    merchant?: string;
    description?: string;
  };
  flag?: ReactNode;
  hideTextIcon?: boolean;
}

function MediaInfoCell({
  media,
  hideTextIcon = false,
  flag,
}: MediaInfoCellProps) {
  if (!media.title && !media.subtitle && !media.avatar) {
    return null;
  }

  return (
    <Link to={media.url || '#'}>
      <div className='d-flex align-items-center'>
        <div className={'symbol symbol-40px me-2'}>
          <HIcon
            image={media.avatar}
            text={hideTextIcon ? undefined : media.initial || media.title}
            size={40}
          />
          {flag}
        </div>
        <div className='d-flex flex-column'>
          <div className='text-gray-800 text-hover-primary mb-1'>
            {media.title}
          </div>
          <span className={'fw-light'}>
            {media.merchant && (
              <img
                title={media.merchant}
                src={icons[media.merchant]}
                width={15}
                height={15}
                style={{ borderRadius: 10, marginRight: 2 }}
              />
            )}
            {media.subtitle}
          </span>
          {media.description && (
            <span className={'fw-lighter'} style={{ fontSize: 12 }}>
              {media.description}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

export default MediaInfoCell;
